import { useSlidesCrudLoadActions } from './useSlidesCrudActions.load'
import { useSlidesCrudMutationActions } from './useSlidesCrudActions.mutations'
import type { SlidesCrudArgs } from './useSlidesCrudActions.types'

export const useSlidesCrudActions = ({
  authHeaders,
  editingId,
  slideForm,
  setSlides,
  setLoading,
  setSlideForm,
  setEditingId,
  setSection,
  t,
  requireAuth,
}: SlidesCrudArgs) => {
  const { loadSlides, resetSlideForm, selectForEdit } = useSlidesCrudLoadActions({
    setLoading,
    setSlides,
    setSlideForm,
    setEditingId,
    setSection,
    t,
  })

  const { upsertSlide, deleteSlide, persistOrder } = useSlidesCrudMutationActions({
    authHeaders,
    editingId,
    slideForm,
    setSlides,
    t,
    requireAuth,
    loadSlides,
    resetSlideForm,
  })

  return {
    loadSlides,
    resetSlideForm,
    selectForEdit,
    upsertSlide,
    deleteSlide,
    persistOrder,
  }
}
